import React from "react";
import Rating from 'react-rating';
import { FaRegStar, FaStar } from 'react-icons/fa';
import PrimaryButton from "../common/PrimaryButton";

const StoreUserReviews = ({ customerReview }) => {

    const navigateToUrl = (url) => {
        const urlToLoad =
            customerReview.onTap.FAI.url.includes("?")
                ? customerReview.onTap.FAI.url + "&" + window.location.search.slice(1)
                : customerReview.onTap.FAI.url + "?" + window.location.search.slice(1);
        window.open(urlToLoad, "_blank");
        
    };

    return (
        <div style={{ padding: "16px", fontFamily: "Arial, sans-serif" }}>
            {/* Average Rating Section */}
            <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontSize: "20px", fontWeight: "bold", marginRight: "8px" }}>{customerReview.avgRating}</span>
                    <Rating
                        initialRating={customerReview.avgRating}
                        readonly // Makes the stars non-interactive
                        emptySymbol={<FaRegStar style={{ color: '#dcdcdc' }} />}
                        fullSymbol={<FaStar style={{ color: '#ffa41b' }} />}
                        style={{ marginBottom: "4px" }}
                    />
                    <span style={{ marginLeft: "8px" }}>out of 5</span>
                </div>
                <div style={{ fontSize: "14px", color: "#888" }}>
                    {customerReview.totalRatingCount} total rated
                </div>
            </div>

            {/* User Reviews Section */}
            {
                customerReview.userReview &&
                customerReview.userReview.map((review, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            borderBottom: "1px solid #ddd",
                            padding: "8px 0",
                        }}
                    >
                        <img
                            src={review.userImage}
                            alt={review.userName}
                            style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                marginRight: "16px",
                            }}
                        />
                        <div>
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                                {review.userName}
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Rating
                                    initialRating={review.ratingPercentage}
                                    readonly // Makes the stars non-interactive
                                    emptySymbol={<FaRegStar style={{ color: '#dcdcdc' }} />}
                                    fullSymbol={<FaStar style={{ color: '#ffa41b' }} />}
                                    style={{ marginBottom: "4px" }}
                                />
                                <span style={{ marginLeft: "8px", fontSize: "14px", fontWeight: "bold" }}>
                                    {review.ratingPercentage.toFixed(1)}
                                </span>
                                <span style={{ marginLeft: "8px", fontSize: "14px", color: "#888" }}>
                                    {new Date(review.createdTime).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}

            {/* View All Button */}
            <div style={{ textAlign: "center", marginTop: "16px" }}>
                {/* <button
                    style={{
                        padding: "8px 16px",
                        border: "2px solid #28a745",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        color: "#28a745",
                        fontSize: "16px",
                        cursor: "pointer",
                    }}
                    onClick={() => navigateToUrl(customerReview.onTap.FAI.url)}
                >
                    View All
                </button> */}
                <PrimaryButton label="View All" onClick={() => navigateToUrl(customerReview.onTap.FAI.url)} />
            </div>
        </div>
    );
};

export default StoreUserReviews;
